const key = 'applications';

// reversing the order using the added ts
export const sortApplicatons = (applications) => {
    return applications.sort(function (first, second) {
        if (first.position < second.position) {
            return -1;
        }

        if (first.position > second.position) {
            return 1;
        }

        // names must be equal
        return 0;
    });
};


export const applicationsSelector = (state, max = 2) => {
    const apps = state[key].records.ids.map((id) => {
        return state[key].records.byId[id];
    });

    return apps.slice(0, max);
};
export const activeApplicationSelector = (state) => {
    const [head, ...tail] = applicationsSelector(state);
    return head;
};

export const applicationsCountSelector = (state) => {
    return state[key].records.ids.length;
};
